<template>
  <div class="spacer"></div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .spacer {
    display: inline-block;
    width: 100%;
    padding: 30px;
    border: 0px solid #F9FAFC;

    @media screen and (max-width: 320px) {
      padding: 25px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/Spacer.vue